import { useEffect, useState } from "react"
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast"
import { ISolicitacaoSd11, ISolicitarClienteDto, ISolicitarDto, ISolicitarRepresentanteDto } from "../../../Dtos/Comercial/Solicitar/SolicitarDtos"
import LoadingPage from "../../../Components/Loading/Loading"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import AppLayout from "../../../Components/Layout/Layout"
import ApiService from "../../../Config/ApiConfig"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import { Col, Row } from "reactstrap"
import { Fieldset } from "../../../Components/Fieldset/Fieldset"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import { Select } from "../../../Components/Select/Select"
import { InputData } from "../../../Components/Forms/InputData/InputData"
import { sd92motivsolicitacaoEnum } from "../../../Dtos/Comercial/Solicitacoes/SolicitacoesDtos"
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table"
import { Checkbox } from "../../../Components/Forms/Checkbox/Checkbox"
import styled from "styled-components"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import { InputNumber } from "../../../Components/Forms/InputNumber/InputNumber"
import { useNavigate } from "react-router-dom"

export const FormSolicitarLicencaPage = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false)
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })
    const [formData, setFormData] = useState<ISolicitarDto>({} as ISolicitarDto)
    const [sd40s, setsd40s] = useState<Array<ISolicitarClienteDto>>([])
    const [sd41s, setSd41s] = useState<Array<ISolicitarRepresentanteDto>>([])
    const [sd11s, setSd11s] = useState<Array<ISolicitacaoSd11>>([])
    const [selectedSd11s, setSelectedSd11s] = useState<Array<number>>([])

    useEffect(() => {
            async function checkApi() {
                try {
                    const apiService = new ApiService();
    
                    const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })
    
                    if (!response) {
                        navigate("/home");
                    }
                } catch (error) {
                    navigate("/home");
                }
            }
    
            checkApi();
        }, []);

    useEffect(() => {
        buscarRepresentante()
        buscarRepresentantes()
        buscarClientes()
        buscarSistemas()
    }, [])

    const buscarRepresentante = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd41 = await apiService.get<ISolicitarRepresentanteDto>("/solicitarController/buscarRepresentanteUsuarioLogado")

            setFormData(prev => ({ ...prev, representante: sd41 }))
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar representante! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarClientes = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const clientes = await apiService.get<Array<ISolicitarClienteDto>>("/solicitarController/buscarClientes")
            setsd40s(clientes)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar clientes! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarRepresentantes = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const reps = await apiService.get<Array<ISolicitarRepresentanteDto>>("/solicitarController/buscarRepresentantes")
            setSd41s(reps)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar clientes! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarSistemas = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sistemas = await apiService.get<Array<ISolicitacaoSd11>>("/solicitarController/buscarSistemas")
            setSd11s(sistemas)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar sistemas! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleChangeCliente = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;

        const sd40sFilter = sd40s.filter(sd => sd.sd40id === Number(value))

        if (sd40sFilter == null || sd40sFilter.length < 1) return;
        const sd40 = sd40sFilter[0];

        setFormData(prev => ({ ...prev, [name]: sd40 }))
    }

    const handleChangeRepresentante = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;

        const sd41sFilter = sd41s.filter(sd => sd.sd41id === Number(value))

        if (sd41sFilter == null || sd41sFilter.length < 1) return;
        const sd41 = sd41sFilter[0];

        setFormData(prev => ({ ...prev, [name]: sd41 }))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeData = (value: string, nome: string) => {
        setFormData(prev => ({
            ...prev,
            [nome]: value
        }));
    }

    const handleChangeSd11 = (sd11id: number) => {
        setSelectedSd11s(prev => {
            const newSet = new Set(prev);
            if (newSet.has(sd11id)) {
                newSet.delete(sd11id);
            } else {
                newSet.add(sd11id);
            }
            return Array.from(newSet);
        });
    }

    const handleSolicitar = async () => {
        try {
            var msgValidacao = "";
            
            if (formData.representante == null) msgValidacao = "Não foi possível localizar o representante!"
            if (formData.cliente == null) msgValidacao = "Não foi possível localizar o cliente!" 
            if (formData.numeroContrato == null || formData.dataContrato == null) msgValidacao = "Informe os dados do contrato!"
            if (formData.motivoSolicitacao == null || formData.motivoSolicitacao === "") msgValidacao = "Informe o uso da solicitação"
            if (selectedSd11s.length < 1) msgValidacao = "Selecione pelo menos um sistema!"

            if(msgValidacao !== ""){
                setToastOpcoes({ type: "error", visible: true, mensagem: msgValidacao })
                return
            }
            setLoading(true)
            const dados: ISolicitarDto = {
                ...formData,
                idRepresentante: formData.representante!.sd41id,
                idCliente: formData.cliente!.sd40id,
                sd11ids: selectedSd11s,
                representante: null,
                cliente: null
            }
            
            const apiService = new ApiService();
            await apiService.post("/solicitarController/solicitarLicenca", dados)
            setToastOpcoes({ type: "error", visible: true, mensagem: "Solicitação criada" })
            navigate("/solicitacoes")
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar sistemas! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }

    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <PageTitle title='Solicitar' />
            <FormContainer>
                <Row>
                    <Col md="6">
                        <Row>
                            <Col>
                                <Fieldset legend="Representante">
                                    {sd41s.length < 1 &&(<FormField>
                                        <Label>Representante</Label>
                                        <Input
                                            name="representante"
                                            value={`${formData.representante?.sd41cnpj} - ${formData.representante?.sd41nome}`}
                                            disabled
                                        />
                                    </FormField>)}
                                    {sd41s.length > 0 && (<FormField >
                                        <Label>Representantes</Label>
                                        <Select
                                            name="representante"
                                            onChange={handleChangeRepresentante}
                                        >
                                            <option >Selecione o Representante...</option>
                                            {
                                                sd41s.map(sd41 => {
                                                    return (
                                                        <option selected={sd41.sd41id === formData.representante?.sd41id} value={sd41.sd41id} >{sd41.sd41cnpj} - {sd41.sd41nome}</option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormField>)}

                                </Fieldset>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '15px' }}>
                            <Col>
                                <Fieldset legend="Cliente Licenciado">
                                    <FormField >
                                        <Label>Cliente</Label>
                                        <Select
                                            name="cliente"
                                            onChange={handleChangeCliente}
                                        >
                                            <option >Selecione o cliente...</option>
                                            {
                                                sd40s.map(sd40 => {
                                                    return (
                                                        <option selected={sd40.sd40id === formData.cliente?.sd40id} value={sd40.sd40id} >{sd40.sd40cnpj} - {sd40.sd40nome}</option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormField>
                                    <Row>
                                        <Col md="6">
                                            <FormField>
                                                <Label>Contato</Label>
                                                <Input
                                                    name="contato"
                                                    value={formData.cliente?.sd40contato}
                                                    disabled
                                                />
                                            </FormField>
                                        </Col>
                                        <Col md="2">
                                            <FormField>
                                                <Label>DDD</Label>
                                                <Input
                                                    name="ddd"
                                                    value={formData.cliente?.sd40ddd1}
                                                    disabled
                                                />
                                            </FormField>
                                        </Col>
                                        <Col md="4">
                                            <FormField>
                                                <Label>Telefone</Label>
                                                <Input
                                                    name="fone"
                                                    value={formData.cliente?.sd40fone1}
                                                    disabled
                                                />
                                            </FormField>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormField>
                                                <Label>E-mail</Label>
                                                <Input
                                                    name="email"
                                                    value={formData.cliente?.sd40email}
                                                    disabled
                                                />
                                            </FormField>
                                        </Col>
                                    </Row>
                                </Fieldset>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '15px' }}>
                            <Col>
                                <Fieldset legend="Solicitação">
                                    <Row>
                                        <Col>
                                            <FormField>
                                                <Label>Solicitado para uso:</Label>
                                                <Select
                                                    name="motivoSolicitacao"
                                                    onChange={handleChange}
                                                >
                                                    <option value="" >Selecione...</option>
                                                    <option value={sd92motivsolicitacaoEnum.OFICIAL.valueOf()}>OFICIAL</option>
                                                    <option value={sd92motivsolicitacaoEnum.DEMONSTRACAO.valueOf()}>DEMONSTRACAO</option>
                                                    <option value={sd92motivsolicitacaoEnum.IMPLANTACAO.valueOf()}>IMPLANTACAO</option>
                                                </Select>
                                            </FormField>
                                        </Col>
                                    </Row>
                                </Fieldset>
                            </Col>
                        </Row>
                    </Col>
                    <Col md="6">
                        <Row>
                            <Col>
                                <Fieldset legend="Contrato">
                                    <Row>
                                        <Col>
                                            <FormField>
                                                <Label>Número</Label>
                                                <InputNumber
                                                    name="numeroContrato"
                                                    value={formData.numeroContrato}
                                                    onChange={handleChange}
                                                    maxCharacters={5}
                                                />
                                            </FormField>
                                        </Col>
                                        <Col>
                                            <InputData
                                                name="dataContrato"
                                                initialValue={formData.dataContrato}
                                                label="Data"
                                                onChange={(value) => handleChangeData(value, "dataContrato")}
                                            />
                                        </Col>
                                    </Row>
                                </Fieldset>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: '15px' }}>
                            <Col>
                                <Fieldset legend="Licença">
                                    <Row>
                                        <Col>
                                            <Fieldset legend="Formais">
                                                <Row>
                                                    <Col>
                                                        <FormField>
                                                            <Label>Aquisição</Label>
                                                            <InputNumber
                                                                name="aquisicao"
                                                                value={formData.aquisicao}
                                                                onChange={handleChange}
                                                            />
                                                        </FormField>
                                                    </Col>
                                                    <Col>
                                                        <FormField>
                                                            <Label>Locação</Label>
                                                            <InputNumber
                                                                name="locacao"
                                                                value={formData.locacao}
                                                                onChange={handleChange}
                                                            />
                                                        </FormField>
                                                    </Col>
                                                </Row>
                                            </Fieldset>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Fieldset legend="Provisoria">
                                                <Row>
                                                    <Col>
                                                        <FormField>
                                                            <Label>Qtde</Label>
                                                            <InputNumber
                                                                name="quantidadeProvisoria"
                                                                value={formData.quantidadeProvisoria}
                                                                onChange={handleChange}
                                                            />
                                                        </FormField>
                                                    </Col>
                                                    <Col>
                                                        <InputData
                                                            name="dataProvisoria"
                                                            initialValue={formData.dataProvisoria}
                                                            label="Data"
                                                            onChange={(value) => handleChangeData(value, "dataProvisoria")}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fieldset>
                                        </Col>
                                    </Row>
                                </Fieldset>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row style={{ marginTop: '15px' }}>
                    <Col>
                        <Fieldset legend="Sistemas">
                            <ScrollableTableContainer>
                                <TableContainer>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <Th></Th>
                                                <Th>#</Th>
                                                <Th>Sigla</Th>
                                                <Th>Sistema</Th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sd11s.map(sd11 => (
                                                <tr key={sd11.sd11id}>
                                                    <Td>
                                                        <Checkbox onChange={(value) => handleChangeSd11(sd11.sd11id)} />
                                                    </Td>
                                                    <Td>{sd11.sd11id}</Td>
                                                    <Td>{sd11.sd11sigla}</Td>
                                                    <Td>{sd11.sd11descr}</Td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </TableContainer>
                            </ScrollableTableContainer>
                        </Fieldset>
                    </Col>
                </Row>
                <Row style={{ marginTop: '15px' }}>
                    <Col>
                        <ButtonPrimary type="button" onClick={handleSolicitar}>
                            Solicitar
                        </ButtonPrimary>
                    </Col>
                </Row>
            </FormContainer>
        </AppLayout>
    )
}

const ScrollableTableContainer = styled.div`
  height: 300px; // Altura fixa
  overflow-y: auto; // Habilita a barra de rolagem vertical
  border: 1px solid #ccc; // Borda opcional para melhor visualização
  border-radius: 4px; // Borda arredondada
  box-shadow:  ${prop => prop.theme.sombras.padrao};
`;